import React from 'react';

import EmptyContainer from '@/pages/common/empty/components/EmptyContainer';

import noResults from '@/pages/common/empty/images/noResults.png';

export interface NoRowsOverlayContext {
  // Returns whether there are any beneficiaries at all (unfiltered total > 0).
  // When true, an empty grid means the active search/filters matched nothing;
  // when false, there simply are no beneficiaries yet.
  getHasAnyRecords?: () => boolean;
}

interface NoRowsOverlayProps {
  context?: NoRowsOverlayContext;
}

const MESSAGES = {
  // No beneficiaries exist at all.
  empty: {
    title: { id: 'configurations.company.beneficiaries.empty.title', defaultMessage: 'No beneficiaries yet' },
    description1: {
      id: 'configurations.company.beneficiaries.empty.description1',
      defaultMessage: 'Beneficiaries you add will appear here.',
    },
    description2: {
      id: 'configurations.company.beneficiaries.empty.description2',
      defaultMessage: 'Add a beneficiary to get started.',
    },
  },
  // Beneficiaries exist, but none match the active search/filters.
  noResults: {
    title: { id: 'configurations.company.beneficiaries.noResults.title', defaultMessage: 'No matching beneficiaries' },
    description1: {
      id: 'configurations.company.beneficiaries.noResults.description1',
      defaultMessage: 'No beneficiaries match your current search or filters.',
    },
    description2: {
      id: 'configurations.company.beneficiaries.noResults.description2',
      defaultMessage: 'Try adjusting your search or clearing the filters.',
    },
  },
};

const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({ context }) => {
  const hasAnyRecords = context?.getHasAnyRecords?.() ?? false;
  const messages = hasAnyRecords ? MESSAGES.noResults : MESSAGES.empty;

  return <EmptyContainer imageSrc={noResults} Icon={null} buttonText={null} {...messages} />;
};

export default NoRowsOverlay;
